/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `at_or_below` - At or below
 * * `at_or_above` - At or above
 */
export type ComparisonOperator = typeof ComparisonOperator[keyof typeof ComparisonOperator];


export const ComparisonOperator = {
  at_or_below: 'at_or_below',
  at_or_above: 'at_or_above',
} as const;
